import * as type from '../actions/types';

const initialState = {
  services: [],
  loading: false,
  error: null,
}

export default function serviceTypes(state = initialState, action) {
  switch (action.type) {
    case type.GET_SERVICE_TYPES_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case type.GET_SERVICE_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        services: action.services
      }
    case type.GET_SERVICE_TYPES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state
  }
}